
import { TextField } from "@mui/material";
import { MenuItem } from "@mui/material";
import Sidebar from "../../Sidebar/Sidebar";
import "../BulkUpload/BulkUpload.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import useBulkUpload from "./useBulkUpload";
import Cookies from 'js-cookie';
import { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../../App";

const BulkUpload = () => {
  const {
    open, isOpen, openView, reportType, setBusinessNature, businessNature, setCollectionBank, CollectionBank, fileInputRef,
    setGender, gender, setIndustry, industry, setSalaryMode, SalaryMode, setSector, sector, setSubsector, subsector, setTitle, title, setcompanytype, companytype, seteducation, education, setloanAdvanceEmi, loanAdvanceEmi, setloanAuthMode, loanAuthMode, setloanBulkType, loanBulkType,
    setloanEsignBy, loanEsignBy, setloanStatus, loanStatus, setmaritalstatus, maritalstatus, setprofessiontype, professiontype, setresidencetype, residencetype, handleChange, insertDataIntoExcel, uploadFile, subsectorArray, sectorArray, industryArray, natureOfBusinessArray, loanStatusBulkUpload } = useBulkUpload();

  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [visible, setvisible] = useState(false);
  const [LeadVisible, setLeadVisible] = useState(false);
  const [BorrowerVisible, setBorrowerVisible] = useState(false);
  const [LoanVisible, setLoanVisible] = useState(false);
  const [CoApplicantVisible, setCoApplicantVisible] = useState(false);
  const [CollateralVisible, setCollateralVisible] = useState(false);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          // console.log(res);
          setLeadVisible(res.data[0].permission.bulk_upload_lead);
          setBorrowerVisible(res.data[0].permission.bulk_upload_borrower);
          setLoanVisible(res.data[0].permission.bulk_upload_loan);
          setCoApplicantVisible(res.data[0].permission.bulk_upload_co_borrower);
          setCollateralVisible(res.data[0].permission.bulk_upload_collateral);
        })
        .catch((err) => {
          // console.log(err);
        })
    };
  }, [token, email]);

  const reportOptions = [
    {
      value: "BorrowerBulkUpload",
      label: "Borrower Bulk Upload",
      show: visible || BorrowerVisible,
    },
    {
      value: "LoanBulkUpload",
      label: "Loan Bulk Upload",
      show: visible || LoanVisible,
    },
    {
      value: "LeadBulkUpload",
      label: "Lead Bulk Upload",
      show: visible || LeadVisible,
    },
    {
      value: "CoapplicantBulkUpload",
      label: "Co-applicant Bulk Upload",
      show: visible || CoApplicantVisible,
    },
    {
      value: "CollateralBulkUpload",
      label: "Collateral Bulk Upload",
      show: visible || CollateralVisible,
    },
  ];

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"BulkUpload"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="content-container-1">
          {/* <h2 className="main-heading">Bulk Upload</h2>
          <br></br> */}
          <div className="wrapper-upload">
            <div className="upload-input">
              <TextField
                className="report-field"
                placeholder="Select Data..."
                select
                name="report-type"
                variant="outlined"
                value={reportType}
                size="small"
                sx={{
                  width: "30ch",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#ebebeb",
                    borderRadius: 3,
                    width: "14rem",
                  },
                }}

                onChange={(e) => handleChange(e)}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        borderRadius: "16px",
                        mt: 1,
                        boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
                      },
                    },
                    sx: {
                      borderRadius: "16px",
                      mt: 1,
                      // backdropFilter: "blur(4px)",
                    },
                  },
                }}

              >
                <MenuItem value="ReportType">Select Report Type</MenuItem>

                {reportOptions
                  .filter((option) => option.show)
                  .map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
              </TextField >
            </div>

            <div className="upload-input">
              <button
                className="sampleButton"
                onClick={(e) => insertDataIntoExcel(e)}
              >
                Download Sample File
              </button>
            </div>

            <div className="upload-input">
              <input
                ref={fileInputRef}
                type="file"
                onChange={(e) => uploadFile(e)}
                className="fileButton"
              ></input>
            </div>
            {open && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress size={24} color="primary" />
                <span style={{ marginLeft: '10px', fontSize: '14px', color: '#666' }}>
                  Uploading...
                </span>
              </div>
            )}
          </div>
          {reportType === "BorrowerBulkUpload" && (
            <div className="borrowerupload-data">
              <div>
                1. DOB should be in DD-MM-YYYY format (Only in Text Format).
              </div>
              <div>
                2. Pan Number is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span>
              </div>
              <div>
                3. Mobile Number is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span>
              </div>
              <div>
                4. Email is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span> <br />
              </div>
              <div>
                5. SourceCode is Staff Id of User. <br />
              </div>
              <div>
                6. Company is Mandatory and should be mapped with Branch{" "}
                <span style={{ color: "red" }}>*</span>
              </div>
              <div>
                7. Branch is Mandatory and should be mapped with Company{" "}
                <span style={{ color: "red" }}>*</span>
              </div>
              <div>
                8. Created Date should be in DD-MM-YYYY format (Only in Text
                Format).
              </div>

              <div>
                <label>
                  9. Office Subsector should have following values only.
                </label>
                <br />
                <TextField
                  className="input-field"
                  select
                  name="subsector"
                  value={subsector}
                  size="small"
                  sx={{
                    width: "55ch",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 3,
                      width: "14rem",
                    },
                  }}
                  onChange={(e) => setSubsector(e.target.value)}
                >
                  {subsectorArray.map((subsector, i) => (
                    <MenuItem key={i} value={subsectorArray[i]}>
                      {subsector}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div>
                <label>
                  10. Office Sector should have following values only.
                </label>
                <br />
                <TextField
                  className="input-field"
                  select
                  name="sector"
                  value={sector}
                  size="small"
                  sx={{
                    width: "55ch",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 3,
                      width: "14rem",
                    },
                  }}
                  onChange={(e) => setSector(e.target.value)}
                >
                  {sectorArray.map((sector, i) => (
                    <MenuItem key={i} value={sectorArray[i]}>
                      {sector}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div>
                <label>
                  11. Office Industry should have following values only.
                </label>
                <br />
                <TextField
                  className="input-field"
                  select
                  name="industry"
                  value={industry}
                  size="small"
                  sx={{
                    width: "55ch",
                    "& .MuiOutlinedInput-root": {

                      borderRadius: 3,
                      width: "14rem",
                    },
                  }}
                  onChange={(e) => setIndustry(e.target.value)}
                >
                  {industryArray.map((industry, i) => (
                    <MenuItem key={i} value={industryArray[i]}>
                      {industry}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div>
                <label>
                  12. Nature Of Business should have following values only.
                </label>
                <br />
                <TextField
                  className="input-field"
                  select
                  name="nature-of-business"
                  value={businessNature}
                  size="small"
                  sx={{
                    width: "55ch",
                    "& .MuiOutlinedInput-root": {

                      borderRadius: 3,
                      width: "14rem",
                    },
                  }}
                  onChange={(e) => setBusinessNature(e.target.value)}
                >
                  {natureOfBusinessArray.map((businessNature, i) => (
                    <MenuItem key={i} value={natureOfBusinessArray[i]}>
                      {businessNature}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div>
                <label>13. Title should have following values only.</label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={title}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setTitle(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">MR</MenuItem>
                  <MenuItem value="LoanBulkUpload"> MRS</MenuItem>
                  <MenuItem value="LeadBulkUpload">MS</MenuItem>
                  <MenuItem value="OTHERS">Others</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  14. Marital Status should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={maritalstatus}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setmaritalstatus(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">MARRIED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> SINGLE</MenuItem>
                  <MenuItem value="LoanBulkUpload"> WIDOW</MenuItem>
                  <MenuItem value="LoanBulkUpload"> DIVORCEE</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  15. Residence Type should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={residencetype}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setresidencetype(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">RENTED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> OWNED</MenuItem>
                  <MenuItem value="LoanBulkUpload">PARENTAL</MenuItem>
                  <MenuItem value="LoanBulkUpload"> COMPANY PROVIDED</MenuItem>
                </TextField>
              </div>

              <div>
                <label>16. Gender should have following values only.</label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={gender}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">MALE</MenuItem>
                  <MenuItem value="LoanBulkUpload"> FEMALE</MenuItem>
                </TextField>
              </div>

              <div>
                <label>17. Education should have following values only.</label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={education}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => seteducation(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">10TH</MenuItem>
                  <MenuItem value="LoanBulkUpload"> 12TH</MenuItem>
                  <MenuItem value="LoanBulkUpload"> GRADUATE</MenuItem>
                  <MenuItem value="LoanBulkUpload"> POST-GRADUATE</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  18. Profession Type should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={professiontype}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setprofessiontype(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">SALARIED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> SELF-EMPLOYED</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  19. Collection Bank Type should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={CollectionBank}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setCollectionBank(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">CC</MenuItem>
                  <MenuItem value="LoanBulkUpload"> SAVINGS</MenuItem>
                  <MenuItem value="LoanBulkUpload"> OVRDRAFT</MenuItem>
                  <MenuItem value="LoanBulkUpload"> CURRENT</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  20. Company Type should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={companytype}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setcompanytype(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">
                    PROPRIETORSHIP/PARTNERSHIP/LLP FIRM
                  </MenuItem>
                  <MenuItem value="LoanBulkUpload"> LTD/PVT LTD FIRM</MenuItem>
                  <MenuItem value="LoanBulkUpload"> GOVERNMENT FIRM</MenuItem>
                  <MenuItem value="LoanBulkUpload">TRUST FIRM</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  21. Salary Mode should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={SalaryMode}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setSalaryMode(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">CASH</MenuItem>
                  <MenuItem value="LoanBulkUpload"> CHEQUE</MenuItem>
                  <MenuItem value="LoanBulkUpload"> BANK TRANSFER</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  22. Business Type should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={SalaryMode}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setSalaryMode(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">GROCERY</MenuItem>
                  <MenuItem value="LoanBulkUpload"> DAIRY</MenuItem>
                  <MenuItem value="LoanBulkUpload"> VEGETABLE</MenuItem>
                  <MenuItem value="LoanBulkUpload"> MEDICAL</MenuItem>
                </TextField>
              </div>

              <div>
                <label>
                  23. Borrower Status should have following values only.
                </label>
                <br />
                <TextField
                  className="report-field"
                  select
                  name="report-type"
                  value={SalaryMode}
                  size="small"
                  sx={{ width: "55ch" }}
                  onChange={(e) => setSalaryMode(e.target.value)}
                >
                  <MenuItem value="BorrowerBulkUpload">INCOMPLETE</MenuItem>
                  <MenuItem value="LoanBulkUpload"> NEW</MenuItem>
                  <MenuItem value="LoanBulkUpload"> API APPROVED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> API REJECTED</MenuItem>
                  <MenuItem value="BorrowerBulkUpload">
                    ANALYST APPROVED
                  </MenuItem>
                  <MenuItem value="LoanBulkUpload"> ANALYST REJECTED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> QUERY RAISED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> QUERY RESOLVED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> MANAGER APPROVED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> MANAGER REJECTED</MenuItem>
                  <MenuItem value="LoanBulkUpload"> REVERT TO ANALYST</MenuItem>
                </TextField>
              </div>
            </div>
          )}

          {reportType === "LeadBulkUpload" && (
            <div>
              <p className="lead-Data">
                1. Lead Mobile Number is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span> <br />
                <br />
                2. Lead Email is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span> <br />
                <br />
                3. Lead Pan Number is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                4. Lead DOB should be in DD-MM-YYYY(Only in Text Format).
                <br />
                <br />
                5. Lead Branch Code is Mandatory and Should be Mapped with
                Company <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                6. Lead Company Code is Mandatory and Should be Mapped with
                Branch <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                7. Source is Staff Id of user.
                <br />
                <br />
                8. Status will have 2 values either approved or rejected.
                <br />
                <br />
                9. CreatedDate should be in DD-MM-YYY(Only in Text Format).
                <br />
                <br />
                10. Lead Id is Mandatory and Should be Unique{" "}
                <br />
                <br />
                11. Lead Type is Mandatory and Should be Borrower or Co Borrower {" "}
                <span style={{ color: "red" }}>*</span>
                <br />
                <br />
              </p>
            </div>
          )}

          {reportType === "LoanBulkUpload" && (
            <div>
              <p className="lead-Data">
                1. Loan Product Id is Mandatory{" "}
                <span style={{ color: "red" }}>*</span> <br />
                <br />
                2. Disbursedment Date should be in DD-MM-YYYY format(Only in
                Text Format). <br />
                <br />
                3. Borrower UniqueNo is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span> <br />
                <br />
                4. Release Date should be in DD-MM-YYYY format(Only in Text
                Format).
                <br />
                <br />
                5. Tenure Start Date should be in DD-MM-YYYY format(Only in Text
                Format).
                <br />
                <br />
                6. Emi Start Date should be in DD-MM-YYYY format(Only in Text
                Format)
                <br />
                <br />
                7. Emi Last Date should be in DD-MM-YYYY format(Only in Text
                Format).
                <br />
                <br />
                8. Loan Created Date Should be in DD-MM-YYYY format(Only in Text
                Format).
                <br />
                <br />
                9. Loan Id is Mandatory and should be unique{" "}
                <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                <div>
                  <label>
                    10. Loan Type should have following values only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanBulkType}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanBulkType(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">NEW</MenuItem>
                    <MenuItem value="LoanBulkUpload"> REPEAT</MenuItem>
                    <MenuItem value="LeadBulkUpload">TOPUP</MenuItem>
                    <MenuItem value="LeadBulkUpload">RESTRUCTURED</MenuItem>
                    <MenuItem value="LeadBulkUpload">TOPUP + BT</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    11. Loan Auth Mode should have following values only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanAuthMode}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanAuthMode(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">api</MenuItem>
                    <MenuItem value="LoanBulkUpload"> esign</MenuItem>
                    <MenuItem value="LeadBulkUpload">physical</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    12.Loan Esign By should have following values only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanEsignBy}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanEsignBy(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">
                      Leegality-OTP
                    </MenuItem>
                    <MenuItem value="LoanBulkUpload"> Leegality-BIO</MenuItem>
                    <MenuItem value="LeadBulkUpload">Digio-OTP</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    13. Loan Advance Emi Number should have following values
                    only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanAdvanceEmi}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanAdvanceEmi(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">0</MenuItem>
                    <MenuItem value="LoanBulkUpload"> 1</MenuItem>
                    <MenuItem value="LeadBulkUpload">2</MenuItem>
                    <MenuItem value="LeadBulkUpload">3</MenuItem>
                    <MenuItem value="LeadBulkUpload">4</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    14. Loan Status should have following values only.
                  </label>
                  <br />
                  <TextField
                    className="input-field"
                    select
                    name="subsector"
                    value={loanStatus}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanStatus(e.target.value)}
                  >
                    {loanStatusBulkUpload.map((loanStatus, i) => (
                      <MenuItem key={i} value={loanStatusBulkUpload[i]}>
                        {loanStatus}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <br />
              </p>
            </div>
          )}

          {reportType === "CoapplicantBulkUpload" && (
            <div>
              <p className="lead-Data">
                1. Coapplicant Id is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span> <br />
                <br />
                2. Coapplicant DOB should be in DD-MM-YYYY(Only in Text Format).
                <br />
                <br />
                3. Coapplicant Borrower Uniqueno is Mandatory{" "}
                <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                4. Coapplicant Loan Id is Mandatory{" "}
                <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                <div>
                  <label>
                    5. Coapplicant Marital Status should have following values
                    only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanBulkType}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanBulkType(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">MARRIED</MenuItem>
                    <MenuItem value="LoanBulkUpload"> SINGLE</MenuItem>
                    <MenuItem value="LeadBulkUpload">WIDOW</MenuItem>
                    <MenuItem value="LeadBulkUpload">DIVORCEE</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    6. Coapplicant Education should have following values only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanAuthMode}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanAuthMode(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">10TH</MenuItem>
                    <MenuItem value="LoanBulkUpload"> 12TH</MenuItem>
                    <MenuItem value="LeadBulkUpload">GRADUATE</MenuItem>
                    <MenuItem value="LeadBulkUpload">POST-GRADUATE</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    7.Coapplicant Residence Type should have following values
                    only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanEsignBy}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanEsignBy(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">RENTED</MenuItem>
                    <MenuItem value="LoanBulkUpload"> OWNED</MenuItem>
                    <MenuItem value="LeadBulkUpload">PARENTAL</MenuItem>
                    <MenuItem value="LeadBulkUpload">COMPANY PROVIDED</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    8. Coapplicant Profession Type should have following values
                    only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanAdvanceEmi}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanAdvanceEmi(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">SALARIED</MenuItem>
                    <MenuItem value="LoanBulkUpload"> SELF-EMPLOYED</MenuItem>
                  </TextField>
                </div>
                <br />
                <div>
                  <label>
                    9. Coapplicant Nature Of Business should have following
                    values only.
                  </label>
                  <br />
                  <TextField
                    className="input-field"
                    select
                    name="nature-of-business"
                    value={businessNature}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setBusinessNature(e.target.value)}
                  >
                    {natureOfBusinessArray.map((businessNature, i) => (
                      <MenuItem key={i} value={natureOfBusinessArray[i]}>
                        {businessNature}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <br />
                <div>
                  <label>10. Gender should have following values only.</label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={gender}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">MALE</MenuItem>
                    <MenuItem value="LoanBulkUpload"> FEMALE</MenuItem>
                  </TextField>
                </div>
                <br />
              </p>
            </div>
          )}

          {reportType === "CollateralBulkUpload" && (
            <div>
              <p className="lead-Data">
                1. Collateral Id is Mandatory and Should be Unique{" "}
                <span style={{ color: "red" }}>*</span> <br />
                <br />
                2. Collateral Borrower UniqueNo is Mandatory{" "}
                <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                3. Collateral Loan Id is Mandatory{" "}
                <span style={{ color: "red" }}>*</span>
                <br />
                <br />
                <div>
                  <label>
                    4. Collateral Type should have following values only.
                  </label>
                  <br />
                  <TextField
                    className="report-field"
                    select
                    name="report-type"
                    value={loanBulkType}
                    size="small"
                    sx={{ width: "55ch" }}
                    onChange={(e) => setloanBulkType(e.target.value)}
                  >
                    <MenuItem value="BorrowerBulkUpload">COMMERCIAL</MenuItem>
                    <MenuItem value="LoanBulkUpload"> RESIDENCE</MenuItem>
                  </TextField>
                </div>
                <br />
              </p>
            </div>
          )}
        </div>
        <ToastContainer />
      </div >
    </>
  );
};

export default BulkUpload;
